// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminFreightBookings = (client) => ({
    /**
     * `GET /admin/freight-bookings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListFreightBookings
     * @source packages/medusa-plugin-searates-v2/src/api/admin/freight-bookings/route.ts
     */
    list: (query, headers) => client.fetch("/admin/freight-bookings", { method: "GET", query, headers }),
    /**
     * `GET /admin/freight-bookings/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetFreightBooking
     * @source packages/medusa-plugin-searates-v2/src/api/admin/freight-bookings/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/freight-bookings/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=freight-bookings.js.map